import React, { useState } from 'react';
import { Icon } from '../../../../components';
import ButtonAnnul from '../../../events/components/ButtonAnnul';
import {
  ContainerBottom,
  ContainerFullScreen,
  EventDetailContainer
} from '../../../events/modules/eventDetail/components/styles';
import Spinner from '../../../../components/Spinner';
import { DivBox, Separator, Title, TitleBox } from './styles';
import EventSchedule from '../../../events/components/eventSchedule';
import Processing from '@/presentation/components/Processing';
import Modal from '../../../procedures/components/Modal/Modal';
import ContentModalTwoButtons from '../../../procedures/components/ContentModalTwoButtons';
import iconCancel from '../../../../../assets/illustrations/cancel-procedure.svg';
import ReusableDate from '../../../../reusables/Date';
import Back from '@/presentation/reusables/Button/Back';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';

interface ReservationDetailViewProps {
  isLoading: boolean;
  goBackButton: () => void;
  reservationDetail: any;
  isProcessing: boolean;
  onCancelReservation: (idEvent: number) => void;
  restriction: boolean;
  setRestriction: (show: boolean) => void;
}

const ReservationDetailView = ({
  isLoading,
  goBackButton,
  reservationDetail,
  isProcessing,
  onCancelReservation,
  restriction,
  setRestriction
}: ReservationDetailViewProps) => {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const schedule = [
    {
      date: reservationDetail?.date,
      endTime: reservationDetail?.hourEnd,
      idDay: 1,
      startTime: reservationDetail?.hourStart
    }
  ];

  return (
    <>
      <ContainerFullScreen data-testid="cmp-event-detail-view">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ContainerBottom>
            <Back onClick={goBackButton} dataTestid="btn-back-event-detail" />
          </ContainerBottom>
        </div>
        {isLoading && <Spinner />}
        {reservationDetail && !isLoading && (
          <EventDetailContainer>
            <div className="eventDetailContainer">
              <Title data-testid="cmp-eventDetail-title">
                {reservationDetail?.type === 'T' && <>Tablet</>}
                {reservationDetail?.type === 'C' && <>Computadora</>}
              </Title>
              <div className="fields">
                <EventSchedule
                  isCanceled={false}
                  isOnly
                  schedule={schedule}
                  isReservation
                />
              </div>
              <ReusableDate
                size="large"
                endDate={reservationDetail?.date}
                fontSize="14px"
                gap="8px"
                startDate={reservationDetail?.date}
                style={{ marginBottom: '6px' }}
              />

              <DivBox>
                <TitleBox>Recuerda</TitleBox>
                <ul>
                  {reservationDetail.type === 'T' && (
                    <li>El uso es exclusivo dentro del campus.</li>
                  )}
                  <li>
                    El tiempo máximo de tolerancia es
                    {` ${reservationDetail?.toleranceTime}`} minutos. Pasado ese
                    tiempo se anulará tu reserva automáticamente.
                  </li>
                </ul>
              </DivBox>
              <Separator>
                <Icon
                  name="map-pin"
                  size={12}
                  color="var(--neutrals-neutral02)"
                />
                <span style={{ marginLeft: '6px' }}>¿Cómo llegar?</span>
              </Separator>
              <DivBox>
                <TitleBox>{reservationDetail.ubication}</TitleBox>
                {reservationDetail.address}
              </DivBox>
              <ButtonAnnul
                onClick={() => setShowCancelModal(true)}
                buttonText="Anular reserva"
              />
            </div>
          </EventDetailContainer>
        )}
      </ContainerFullScreen>
      <Processing isOpen={isProcessing} />
      <Modal
        show={showCancelModal}
        handleClose={() => setShowCancelModal(false)}
      >
        <ContentModalTwoButtons
          img={iconCancel}
          title="¿Estás seguro de anular tu reserva?"
          subtitle="Al aceptar esta acción, recuerda que tendrás que volver a solicitarlo."
          showInfo={false}
          textButton1="Sí, anular"
          onClickButton1={() => {
            setShowCancelModal(false);
            onCancelReservation(reservationDetail.id);
          }}
          textButton2="Cancelar"
          onClickButton2={() => setShowCancelModal(false)}
        />
      </Modal>
      <Modal show={restriction} handleClose={() => setRestriction(false)}>
        <PopPupRestriction handleClick={() => setRestriction(false)} />
      </Modal>
    </>
  );
};

export default ReservationDetailView;
